import { MemberInterface } from "@swivl-mono/types";

export function getAgentName({ agentName, account }: MemberInterface): string {
  if (agentName) {
    return agentName;
  }
  if (account) {
    const { firstName, lastName } = account;
    return [firstName, lastName].filter(Boolean).join(" ");
  }
  return "Unknown agent";
}
